import { api } from '../../../../lib/api'

export const UPDATE_SUBSCRIPTION_PAYMENT_REQUEST = 'UPDATE_SUBSCRIPTION_PAYMENT_REQUEST'
export const UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS = 'UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS'
export const UPDATE_SUBSCRIPTION_PAYMENT_FAILED = 'UPDATE_SUBSCRIPTION_PAYMENT_FAILED'

export const updateSubscriptionPayment = function (merchantId, subscriptionId, isPayed, onComplete) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_SUBSCRIPTION_PAYMENT_REQUEST
    })
    api.updateSubscriptionPayment(merchantId, subscriptionId, isPayed).then(updateSubscriptionPaymentResponse => {
      dispatch({
        type: UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS,
        payload: updateSubscriptionPaymentResponse
      })
      onComplete()
    }).catch(error => {
      dispatch({
        type: UPDATE_SUBSCRIPTION_PAYMENT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/subscription/update-payment-subscription.js